import { css, cx } from '@emotion/css';
import { LabelOnLeftWrap } from 'Shared/forms/Wrap'
import { createSignal, Show } from 'solid-js'
import { Match, Switch } from 'solid-js'
import { LayoutSelector } from 'Shared/backend/widgets/LayoutSelector';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import type {Layout} from 'Shared/model/Components';
import { useLayout } from 'Shared/backend/LayoutProvider';
import { Component, AddWrap } from 'Shared/backend/widgets/Component';

export function IntegratedSelectorAndComponent(P:Layout & {label:string,contentFieldName:string,options:string[],required?:boolean,expanded?:() => boolean,setExpanded?:()=>void})
{
	const sw = useStore();
	const lo = useLayout();

//FIXME the ...P hack?
	return (
		<Switch>
			<Match when={!lo.layout() && P.layout=='styles'}>
				<StoreProvider {...sw} location={[...sw.location,P.contentFieldName]}>
					<IntegratedSelectorAndComponent {...P} {...P.content} contentFieldName='content' />
				</StoreProvider>
			</Match>
			<Match when={true}>
				<IntegratedSelectorAndComponentImpl {...P} />
			</Match>
		</Switch>
	);
}

function IntegratedSelectorAndComponentImpl(P:Layout & {label:string,contentFieldName:string,options:string[],required?:boolean,expanded?:() => boolean,setExpanded?:()=>void})
{
	const sw = useStore();
	const lo = useLayout();

	const layoutBarStyle = css({
		display: 'flex',
		gap: '1em',
		alignItems: 'center', 
		backgroundColor: 'grey',
		color: 'white',
		padding: '6px 0 6px 14px',

		select: {
			border: 'solid 1px #aaa',
			color: 'white !important',
			fontSize: '1.0em'
		}
	});

	const blockStyle = css({
		display: 'flex',
		flexDirection: 'column',
		borderLeft: 'solid 5px grey',
		paddingTop: '1em',
		paddingLeft: '1em',
	});


	let expanded, setExpanded;

	if (P.setExpanded) {
		setExpanded = P.setExpanded;
		expanded = P.expanded;
	}
	else
		[expanded,setExpanded] = createSignal(false);

	const blockExists = () => P.layout != null;

	return (
		<StoreProvider {...sw} location={[...sw.location,P.contentFieldName]}>
			<div>
				<Switch>
					<Match when={blockExists()}>
						<a class={layoutBarStyle} onClick={() => setExpanded(!expanded())}>
							<i class={cx('fas',expanded() ? 'fa-caret-down' : 'fa-caret-right')} />

							<label>{P.label}</label>
							<Show when={lo.layout()}>
								<LayoutSelector {...P} expand={() => setExpanded(true)} />
							</Show>
						</a>
					</Match>
					<Match when={true}>
						<Show when={lo.layout()} fallback={<label>{P.label}</label>}>
							<LabelOnLeftWrap label={P.label}>
								<LayoutSelector {...P} expand={() => setExpanded(true)} />
							</LabelOnLeftWrap>
						</Show>
					</Match>
				</Switch>
				<Show when={blockExists() && expanded()}>
					<div class={blockStyle}>
						<Show when={lo.layout()}>
							<div class={css({display:'flex', justifyContent:'flex-end'})}>
								<AddWrap {...P} />
							</div>
						</Show>
						<Component {...P} />
					</div>
				</Show>
			</div>
		</StoreProvider>
	);
}


